import { AlmanacStampEvent } from "../types/almanac"
import { collectAlmanacStamps } from "./almanacNormalize"

type Listener = (stamps: AlmanacStampEvent[]) => void

const listeners = new Set<Listener>()
/** Stamps waiting while delivery is paused (e.g. another Modal is open). */
let deferred: AlmanacStampEvent[] = []
let paused = false

export function subscribeAlmanacStamps(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

function deliver(stamps: AlmanacStampEvent[]): void {
  if (!stamps.length) return
  for (const listener of listeners) {
    listener(stamps)
  }
}

/** Pause stamp modals — use while another full-screen Modal/overlay is up. */
export function pauseAlmanacStamps(): void {
  paused = true
}

/** Flush any stamps queued during pause. */
export function resumeAlmanacStamps(): void {
  paused = false
  if (!deferred.length) return
  const batch = deferred
  deferred = []
  deliver(batch)
}

/** Показать модалки штампов по очереди (несколько — подряд). */
export function enqueueAlmanacStamps(stamps: AlmanacStampEvent[]): void {
  if (!stamps.length) return
  if (paused) {
    deferred = [...deferred, ...stamps]
    return
  }
  deliver(stamps)
}

/** Достаёт штампы из ответа экшена и ставит в очередь модалок. */
export function handleAlmanacStampsFromResponse(res: unknown): AlmanacStampEvent[] {
  const stamps = collectAlmanacStamps(res)
  enqueueAlmanacStamps(stamps)
  return stamps
}
